import type { FC } from "react"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import { useDeleteAssociationLocation } from "@/screens/CustomerProducts/hooks/useDeleteAssociationLocation"

interface RemoveAssociationLocationDialogProps {
  companyProductAssociationLocationId: string
  onClose: () => void
  onSuccess: () => void
}

export const RemoveAssociationLocationDialog: FC<RemoveAssociationLocationDialogProps> = ({
  companyProductAssociationLocationId,
  onClose,
  onSuccess,
}) => {
  const { deleteLocation } = useDeleteAssociationLocation()

  const handleConfirm = async () => {
    const success = await deleteLocation(companyProductAssociationLocationId)
    if (success) {
      onSuccess()
    }
  }

  return (
    <ConfirmationDialog
      title='Are you sure you want to remove this association?'
      content='This action cannot be undone.'
      closeLabel='Go Back'
      confirmLabel='Remove Association'
      isWarning={false}
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  )
}
